common.View.create('admin::layouts.main.LanguageSwitcher', {

    fieldChanges: false,

    onDOMLoad()
    {
        setTimeout(() => {
            const initialLanguage = document.getElementsByTagName('html')[0].getAttribute('lang') || '';

            this.initLanguage(initialLanguage);

            this.element.find('a')
                .on('click', async (event) => {
                    let confirmation = { isConfirmed: false };

                    if (this.fieldChanges) {
                        event.preventDefault();

                        confirmation = await Swal.fire({
                            title: 'Weet u het zeker? U heeft nog niet opgeslagen aanpassingen.',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Ja',
                            confirmButtonColor: '#62de43',
                            cancelButtonText: 'Annuleren',
                        });
                    }

                    if (confirmation.isConfirmed) {
                        const newLanguage = $(event.currentTarget).data('language') || '';
                        this.initLanguage(newLanguage);

                        if (this.fieldChanges) {
                            window.location.href = $(event.currentTarget).attr('href');
                        }
                    }
                })
        }, 1);
    },

    initLanguage(currentLang)
    {
        this.changeLanguage(currentLang);

        $('input,textarea,select').on('change', () => {
            this.fieldChanges = true;
            this.changeLanguage(currentLang);
        });
    },

    changeLanguage(currentLang)
    {
        const $langFields = $('*[data-lang]');

        $langFields.each((index, element) => {
            const lang = $(element).data('lang');

            if (lang === currentLang || lang === '' || currentLang === '') {
                $(element).show().attr('hidden', false);
            } else {
                $(element).hide().attr('hidden', true);
            }
        });

        $('.galaxy\\:\\:common-canvas-Editor:not(.view)').each((index, element) => {
            const vueInstance = $(element).data('vueInstance');
            if (vueInstance) {
                vueInstance.currentLanguage = currentLang;
            }
        });
    }

});
